import {React, useState, useRef} from "react";
import ContactPopup from "../ContactPopup";
// import "./ADCodeRegistration.css";
import "../PrivateLimitedCompany.css"

const ADCodeRegistration = () => {

 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }


  return (
    <div className="page">

      {/* HERO */}
      <div className="hero">

        <h1>AD Code Registration Services</h1>

        <p className="subtitle">
          Get Your AD Code for Smooth Export & Import Clearance
        </p>

        <p className="desc">
          An AD (Authorized Dealer) Code is required for customs clearance at ports and airports in India. We help you obtain and register your AD Code quickly so your import-export shipments run without delays.
        </p>

        <div className="badges">
          <span>✔ Fast Bank Coordination</span>
          <span>✔ Port Registration Support</span>
          <span>✔ Expert Documentation</span>
          <span>✔ Hassle-Free Process</span>
        </div>

        <div className="hero-action">
                    <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
                </div>

      </div>

      {/* WHAT IS AD CODE */}
      <div className="section">
        <h2>What is AD Code?</h2>
        <p>
          An AD Code (Authorized Dealer Code) is a 14-digit code issued by your bank and registered with the customs department. It is mandatory for importers and exporters to clear shipments through Indian ports.
        </p>
      </div>

      {/* IMPORTANCE */}
      <div className="section">
        <h2>Why AD Code is Important?</h2>
        <ul>
          <li>Required for customs clearance</li>
          <li>Mandatory for import/export shipments</li>
          <li>Needed for port and airport registration</li>
          <li>Enables smooth international trade operations</li>
          <li>Linked with your IEC and bank account</li>
        </ul>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of AD Code Registration</h2>
        <ul>
          <li>Easy clearance of export/import goods</li>
          <li>Avoid shipment delays at customs</li>
          <li>Enables port-wise registration</li>
          <li>Ensures DGFT & customs compliance</li>
          <li>Smooth integration with IEC certificate</li>
        </ul>
      </div>

      {/* WHO NEEDS */}
      <div className="section">
        <h2>Who Needs AD Code?</h2>
        <ul>
          <li>Exporters of goods</li>
          <li>Importers handling shipments</li>
          <li>E-commerce exporters</li>
          <li>Manufacturing and trading businesses</li>
          <li>Sea & air freight businesses</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>
        <ul>
          <li>Import Export Code (IEC)</li>
          <li>PAN Card</li>
          <li>GST Certificate (if applicable)</li>
          <li>Bank Account Details</li>
          <li>Cancelled Cheque</li>
          <li>Authorization Letter (if required)</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>AD Code Registration Process</h2>
        <ul>
          <li>Consultation – Verify IEC eligibility</li>
          <li>Bank Coordination – Request AD Code</li>
          <li>Documentation – Prepare required papers</li>
          <li>Port Submission – Register with customs</li>
          <li>Activation – AD Code becomes active</li>
        </ul>
      </div>

      {/* WHY US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Quick AD Code Processing</li>
          <li>Bank & Customs Coordination</li>
          <li>Error-Free Documentation</li>
          <li>Affordable Pricing</li>
          <li>End-to-End Support</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>

        <p><b>Is AD Code mandatory for export?</b> Yes, it is required for customs clearance.</p>
        <p><b>Can one AD Code be used for multiple ports?</b> No, separate registration is required.</p>
        <p><b>How long does it take?</b> Usually 2–5 working days.</p>
        <p><b>Is IEC required?</b> Yes, IEC is mandatory before applying.</p>

      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>Get Your AD Code Today</h2>
        <p>Start exporting without delays at customs.</p>

       <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
      </div>

    </div>
  );
};

export default ADCodeRegistration;